export enum EventState {
  PostEvent = 'post_event',
  PreEvent = 'pre_event',
  PeriEvent = 'peri_event',
}
